import React from "react"

import PageSection from "../../pageSection/pageSection.js"
import H2 from "../../h2/h2.js"

import styles from "./smarterSpender.module.scss"

const SmarterSpenderSection = () => {
  return (
    <PageSection backgroundColor="#5650F0">
      <div
        data-sal="slide-up"
        data-sal-delay="100"
        data-sal-duration="1000"
        data-sal-easing="ease"
      >
        <div className={styles.root}>
          <div className={styles.questionContainer}>
            <H2 className={styles.h2}>"What's a Smarter Spender?" you may be wondering.</H2>
          </div>
          <div className={styles.defContainer}>
            <span className={styles.def}>smärt-<span className={styles.e}>Ə</span>r</span>
            <span className={styles.def}>spen-d<span className={styles.e}>Ə</span>r</span>
            <span className={styles.noun}>/Noun/</span>
            <div className={styles.whiteLine} />
            <p className={styles.defCopy}>A young adult with the confidence to make informed, responsible decisions about money.</p>
          </div>
        </div>
      </div>
    </PageSection>
  )
}

export { SmarterSpenderSection }
